/* ========================================
   LIST TABLE COMPONENT FOR TEMPLATES
   ======================================== */

import { ActiveRow } from '../../../../../../atum-stock-manager-for-woocommerce/assets/js/src/components/list-table/_active-row';
import { default as ListTableGlobals } from '../../../../../../atum-stock-manager-for-woocommerce/assets/js/src/components/list-table/_globals';
import DragScroll from '../../../../../../atum-stock-manager-for-woocommerce/assets/js/src/components/list-table/_drag-scroll';
import ExportSettings from '../../config/_export-settings';
import ScrollBar from '../../../../../../atum-stock-manager-for-woocommerce/assets/js/src/components/list-table/_scroll-bar';
import Tooltip from '../../../../../../atum-stock-manager-for-woocommerce/assets/js/src/components/_tooltip';
import { Utils } from '../../../../../../atum-stock-manager-for-woocommerce/assets/js/src/utils/_utils';

export default class TemplatesList {
	
	constructor(
		private settings: ExportSettings,
		private globals: ListTableGlobals,
		private tooltip: Tooltip,
	) {
		
		// Add active class row function.
		ActiveRow.addActiveClassRow( this.globals.$atumTable );
		
		new DragScroll(this.globals, this.tooltip);
		new ScrollBar(this.globals);
		
		this.bindEvents();
		
	}
	
	bindEvents() {
		
		// Bind jQuery address links.
		this.globals.$atumList.find('a').address();
		
		// Bind the search box.
		this.globals.$searchInput.on('keyup paste search input', (evt: JQueryEventObject) => {
			
			const searchInputVal: any = $(evt.currentTarget).val();
			
			Utils.delay( () => {
				
				if (searchInputVal.length === 0) {
					
					if (searchInputVal != $.address.parameter('s')) {
						$.address.parameter('s', '');
					}
					
				}
				else {
					$.address.parameter('s', searchInputVal);
				}
				
			}, 500);
			
		});
		
		// Bind the page selector input.
		this.globals.$atumList.on('keypress', '#current-page-selector', (evt: JQueryEventObject) => {
			if (evt.which === 13) {
				$.address.parameter('paged', parseInt( $(evt.currentTarget).val() ) || 1 );
			}
		});
		
	}
	
}


// WEBPACK FOOTER //
// ./assets/js/src/components/export-central/_templates-list.ts